import { render, staticRenderFns } from "./CopyToClipboardEl.vue?vue&type=template&id=42a3daf8&scoped=true&"
import script from "./CopyToClipboardEl.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboardEl.vue?vue&type=script&lang=ts&"
import style0 from "./CopyToClipboardEl.vue?vue&type=style&index=0&id=42a3daf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a3daf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
